import { Alert as MuiAlert, TextField as MuiTextField, Paper } from '@mui/material';
import { spacing } from '@mui/system';
import styled from 'styled-components';
import { ReactComponent as Logo } from '../../assets/images/the-tag-system-logo.svg';

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 360px;
  height: 98px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const Alert = styled(MuiAlert)<{ mt?: number; mb?: number }>(spacing);

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

const Styled = {
  Brand,
  Wrapper,
  Alert,
  TextField,
};
export default Styled;
